import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TopBanner } from './components/TopBanner';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '2292460911162237');
    f.fbq('track', 'PageView');
  }, []);
  const testimonials = [{
    name: 'Romina G.',
    location: 'Buenos Aires',
    text: 'Nunca pensé que iba a poder vender algo así desde mi cocina. La primera semana ya recuperé lo que invertí en el pack y más.'
  }, {
    name: 'Claudia M.',
    location: 'Córdoba',
    role: 'Emprendedora gastronómica',
    text: 'Las recetas con dulce de leche y alfajor son una locura. La gente no puede creer que sea comestible. Se vende solo.'
  }, {
    name: 'Valentina R.',
    location: 'Rosario',
    text: 'El tomo de ventas me cambió la cabeza. Yo sabía hacer, pero no sabía cobrar. Ahora sé cómo poner precio y no regalar mi trabajo.'
  }];
  return <div className="w-full min-h-screen bg-neutral-950" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials testimonials={testimonials} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Pricing data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <CostOfInaction data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <WhatsAppButton data-id="element-13" />
    </div>;
}